import { MessageSquare } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';
import { Badge } from '../ui';

/**
 * What an inbound-outreach row IS: a message, and one that came TO the user.
 *
 * Neither fact was on screen. An outreach row is deliberately shaped like a task — same card, same
 * status vocabulary, same tabs — because that is what lets it sort and filter alongside real tasks
 * without a `kind` branch threaded through every consumer. The cost of that reuse is that the row
 * reads as a piece of work the user is supposed to do, and the only tell that it is correspondence
 * from another person is the title copy, "Message from {name}", which is easy to read as a task
 * ABOUT a message.
 *
 * So the badge says both halves: the icon and the word "message" carry the kind, and "Incoming"
 * carries the direction. Direction matters here more than it looks — the same thread view is what a
 * sent outreach would render into, and "who started this" is exactly the question the user asks
 * before deciding whether a reply is owed.
 *
 * One component, used by the card AND the thread dialog, so the two cannot drift into describing the
 * same row differently.
 */
export function OutreachKindBadge({ className }: { className?: string }) {
  const { t } = useTranslation();
  return <Badge variant="waiting-on-a-reply" startIcon={<MessageSquare size={16} />} label={t('tasks.outreach.kindBadge')} className={className} />;
}
